/** UI tab — not an API field. */
export enum SipPlanMode {
  YOUR_PLAN = 'YOUR_PLAN',
  IDEAL_SIPS = 'IDEAL_SIPS'
}

export enum SipActionFilter {
  ALL = 'ALL',
  STOP = 'STOP',
  START = 'START',
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE',
  NO_ACTION = 'NO_ACTION'
}

/** Matches backend category array keys. */
export enum SipCategoryBucketKey {
  stopRecommendations = 'stopRecommendations',
  startRecommendations = 'startRecommendations',
  increaseRecommendations = 'increaseRecommendations',
  decreaseRecommendations = 'decreaseRecommendations',
  noActionFunds = 'noActionFunds'
}

export const SIP_ACTION_FILTER_BUCKET: Partial<Record<SipActionFilter, SipCategoryBucketKey>> = {
  [SipActionFilter.STOP]: SipCategoryBucketKey.stopRecommendations,
  [SipActionFilter.START]: SipCategoryBucketKey.startRecommendations,
  [SipActionFilter.INCREASE]: SipCategoryBucketKey.increaseRecommendations,
  [SipActionFilter.DECREASE]: SipCategoryBucketKey.decreaseRecommendations,
  [SipActionFilter.NO_ACTION]: SipCategoryBucketKey.noActionFunds
}

export const SIP_CATEGORY_BUCKET_TITLES: Record<SipCategoryBucketKey, string> = {
  [SipCategoryBucketKey.stopRecommendations]: 'Stop SIP',
  [SipCategoryBucketKey.startRecommendations]: 'Start SIP',
  [SipCategoryBucketKey.increaseRecommendations]: 'Increase SIP',
  [SipCategoryBucketKey.decreaseRecommendations]: 'Decrease SIP',
  [SipCategoryBucketKey.noActionFunds]: 'No action'
}
